import { render, staticRenderFns } from "./SectionProfile.vue?vue&type=template&id=4b6f46cc&scoped=true"
import script from "./SectionProfile.vue?vue&type=script&lang=js"
export * from "./SectionProfile.vue?vue&type=script&lang=js"
import style0 from "./SectionProfile.vue?vue&type=style&index=0&id=4b6f46cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6f46cc",
  null
  
)

export default component.exports